// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plugin-limit-table-eRuJ1I .semi-table-thead>.semi-table-row>.semi-table-row-head{background-color:transparent;height:16px;padding:4px 8px}.plugin-limit-table-eRuJ1I .semi-table-row{background-color:transparent!important}.plugin-limit-table-eRuJ1I .semi-table-tbody .semi-table-row .semi-table-row-cell{padding:8px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plugin-limit-table": `plugin-limit-table-eRuJ1I`,
	"pluginLimitTable": `plugin-limit-table-eRuJ1I`
};
export default ___CSS_LOADER_EXPORT___;
